import { BaseOapStatus } from '@/classes/SubmissionStatuses/BaseOapStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'

export class ErrorStatus extends BaseOapStatus {
	getStatusText() {
		return 'Error'
	}

	getToolTipText() {
		return {
			title: 'Submission Error',
			body: `Error occurred submitting to (${this.submissionStatus.provider}). Contact salesstudio@precoa.com.`,
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.ERROR
	}
}
